const translations = {
  ACTIVATION_LABEL_PASSWORD: 'Inserisci la password',
  ACTIVATION_LABEL_PASSWORD_CONFIRMATION: 'Ripeti la password',
  ACTIVATION_SUCCESS: 'Congratulazioni, il tuo account è stato attivato.',
  ACTIVATION_TITLE: 'Attivazione Account',
  ACTIVATION_USER_GREETING: 'Salve',
  ACTIVATION_DESCRIPTION: 'completa l\'attivazione del tuo account scegliendo una password. La password deve contenere almeno 8 caratteri e deve contenere almeno un carattere maiuscolo, un carattere numerico e un carattere speciale.',
  ADD_MASTER_USER: 'Aggiungi account Master',
  ADD_EDITOR_USER: 'Aggiungi account Redattore',
  ADD_BASE_USER: 'Aggiungi account Base',
  ADD_DIRECTOR_USER: 'Aggiungi account Direttore',
  ADD_BUYER_USER: 'Aggiungi account Buyer',
  ADD_COMPANY: 'Aggiungi nuova azienda',
  ADD_USER_FIRST_NAME_PLACEHOLDER: 'Nome',
  ADD_USER_LAST_NAME_PLACEHOLDER: 'Cognome',
  ADD_USER_EMAIL_PLACEHOLDER: 'Email',
  ADD_PRODUCT: 'Aggiungi prodotto',
  COMPANY_TITLE: 'aziende',
  COMPANY_TITLE_NOT_EDITOR: 'la mia azienda',
  COMPANY_CREATION_LABEL: 'Vuoi inserire un nuovo profilo azienda?',
  COMPANY_CREATION_BUTTON: 'Inserisci azienda',
  COMPANY_NUSERS: 'N.Utenti',
  COMPANY_ORDERSMADE: 'Ordini fatti',
  COMPANY_OFFICIALDATA: 'dati ufficiali',
  COMPANY_BUSINESSINFO: 'Business Information',
  COMPANY_STRUCTURE_TAB: 'account',
  COMPANY_DOCUMENTS_TAB: 'documenti',
  COMPANY_CONTRACTS_TAB: 'contratti',
  COMPANY_NAME: 'Nome azienda',
  COMPANY_COUNTRY: 'Paese',
  COMPANY_FISCALCODE: 'Codice Fiscale',
  COMPANY_VAT: 'Partita IVA',
  COMPANY_REA: 'Numero di REA',
  COMPANY_CCIAA: 'Numero di CCIAA',
  COMPANY_DUNS: 'Numero Duns',
  COMPANY_REGISTRATION_NUMBER: 'Numero di Registrazione',
  COMPANY_CLIENTCODE: 'Codice cliente',
  COMPANY_LEGALENTITY: 'Natura Legale',
  COMPANY_CEASED: 'L’azienda risulta cessata e non è possibile selezionarla.',
  COMPANY_DIFFERENT_LEGAL_HEAD_OFFICE: 'La sede legale dell\'impresa si trova in provincia di {{province}} e non è possibile selezionarla.',
  COMPANY_QUESTIONNAIRE: 'Questionari',
  COMPANY_STRUCTURE_EMPTY: 'Nessun account MASTER disponibile.',
  ERROR_FIELD_MANDATORY: 'Campi Obbligatori',
  GENERIC_AT_DATE: 'il',
  GENERIC_AND: 'e',
  GENERIC_ON_DATE: 'il',
  GENERIC_AT_TIME: 'alle',
  GENERIC_ANY: 'Qualsiasi',
  GENERIC_ACTIVE: 'Attivo',
  GENERIC_ASSIGN_USER: 'assegna',
  GENERIC_NOT_ACTIVE: 'Non Attivo',
  GENERIC_BASE: 'Base',
  GENERIC_BUYER: 'Buyer',
  GENERIC_COMPANY: 'azienda',
  GENERIC_COMPANY_NAME: 'denominazione',
  GENERIC_CONFIRM: 'conferma',
  GENERIC_CONFIRM_TITLE: 'Vuoi confermare?',
  GENERIC_CUSTOMER: 'Cliente',
  GENERIC_DIRECTOR: 'Direttore',
  GENERIC_EACH: 'ogni',
  GENERIC_EDITOR: 'Redattore',
  GENERIC_EMAIL: 'email',
  GENERIC_INSERTEDBY: 'Aggiunto da',
  GENERIC_INSERT: 'Inserisci',
  GENERIC_LOADING: 'Caricamento...',
  GENERIC_MASTER: 'Master',
  GENERIC_NAME: 'nome',
  GENERIC_OF: 'di',
  GENERIC_FOR: 'per',
  GENERIC_PAGE: 'pagina',
  GENERIC_PLACEHOLDER_INSERTHERE: 'Inserisci qui',
  GENERIC_PENDINGREQUESTS: 'rich.sospese',
  GENERIC_REFUSE: 'rifiuta',
  GENERIC_DECLINE: 'annulla',
  GENERIC_REGISTRATIONSTATUS: 'Stato',
  GENERIC_RESULTS: 'risultati',
  GENERIC_SEARCH: 'cerca',
  GENERIC_SEARCH_BY: 'cerca per',
  GENERIC_SHOWALL: 'Mostra tutte',
  GENERIC_ALL: 'tutte',
  GENERIC_SUBMIT: 'conferma',
  GENERIC_SURNAME: 'cognome',
  GENERIC_TYPE: 'Tipologia',
  GENERIC_TYPE_CLIENT: 'Cliente',
  GENERIC_TYPE_NONCLIENT: 'Non Cliente',
  GENERIC_USERTYPE: 'tipo account',
  GENERIC_USER: 'account',
  GENERIC_UPDATE: 'aggiorna',
  GENERIC_CREATED: 'Creato',
  GENERIC_UPDATED: 'Aggiornato',
  GENERIC_CONTENT_UPDATED: 'CONTENUTO AGGIORNATO',
  GENERIC_WELCOME: 'Benvenuto',
  GENERIC_OFFICIALDATA: 'dati tecnici',
  GENERIC_BUSINESSNAME: 'Ragione sociale',
  GENERIC_OFFICIALDATA_EMPTY: 'Non sono ancora presenti dati tecnici per questa compagnia.',
  GENERIC_QUESTIONNAIRES_EMPTY: 'Non sono ancora presenti questionari per questa compagnia.',
  GENERIC_CANCEL: 'non salvare',
  GENERIC_SAVE: 'salva',
  GENERIC_ADD: 'Aggiungi',
  GENERIC_PARTIALSAVE: 'Salva ma non confermare',
  GENERIC_PRINT: 'Stampa',
  GENERIC_FISCALCODE: 'Codice Fiscale',
  GENERIC_ITALY: 'Italia',
  GENERIC_FOREIGN: 'Estero',
  GENERIC_SELECT: 'Seleziona',
  GENERIC_COUNTRY: 'Stato',
  GENERIC_NEW: 'Nuovo',
  GENERIC_ALREADY_SET: 'Già presente',
  GENERIC_UNAVAILABLE: 'Non disponibile',
  GENERIC_CREDITS: 'Crediti',
  GENERIC_COST: 'Costo',
  GENERIC_CREDITS_LEFT: 'Crediti residui',
  GENERIC_SEND: 'Invia',
  GENERIC_PARTIALSEND: 'Salva, ma non inviare',
  GENERIC_ADDRESS: 'Indirizzo',
  GENERIC_CITY: 'Città',
  GENERIC_PHONE_NUMBER: 'Numero di telefono',
  GENERIC_FISCAL_CODE_OR_ID_NUMBER: 'Codice Fiscale o Numero di Registrazione',
  REGISTRATION_NUMBER_OR_DUNS: 'Numero di Registrazione o Numero Duns',
  GENERIC_CONTINUE: 'Continua',
  GENERIC_SHOWED: 'Visualizzati',
  GENERIC_ORDER: 'ordina per',
  GENERIC_READ_NOTE: 'Leggi commento',
  GENERIC_OPEN_DETAIL: 'Apri dettaglio',
  GENERIC_CLOSE_DETAIL: 'Chiudi dettaglio',
  GENERIC_EMPTY_VALUE: 'n/a',
  ORDER_BY_MOST_RECENT: 'Più recente',
  ORDER_BY_LESS_RECENT: 'Meno recente',
  ORDER_BY_ALPHABETICAL_AZ: 'Alfabetico A-Z',
  ORDER_BY_ALPHABETICAL_ZA: 'Alfabetico Z-A',
  HEADER_COMPANIES: 'aziende',
  HEADER_CONTRACTS: 'contratti',
  HEADER_NOTES: 'note',
  HEADER_REQUESTS: 'richieste',
  HEADER_ORDERS: 'piazzamento ordine',
  HEADER_USERS: 'Account',
  HEADER_ORDERS_LIST: 'Lista ordini',
  NAVIGATION_ITEM_ACCOUNTS: 'Account',
  NAVIGATION_ITEM_ACCOUNTS_CLIENTS: 'Clienti',
  NAVIGATION_ITEM_ACCOUNTS_NON_CLIENTS: 'Non Clienti',
  NAVIGATION_ITEM_ACCOUNTS_NON_EDITORS: 'Redattori',
  NAVIGATION_ITEM_COMPANIES: 'Aziende',
  NAVIGATION_ITEM_COMPANY: 'La mia azienda',
  NAVIGATION_ITEM_PROFILE_LOGOUT: 'Logout',
  NAVIGATION_ITEM_PROFILE_CHANGE_PASSWORD: 'Cambia password',
  NAVIGATION_ITEM_ORDERS: 'Ordini',
  HOME_SUBTITLE: 'Ecco le ultime notifiche di Nando',
  LOGIN_HEADFORM: 'Inserisci le tue credenziali',
  ACCOUNTS_USER_CREATION_COMPANY: 'Hai una nuova azienda cliente?',
  ACCOUNTS_USER_CREATION_COMPANY2: 'Hai una nuova azienda NON cliente?',
  EDITOR_USER_CREATION_LABEL: 'Vuoi creare un nuovo account Redattore?',
  MASTERBASE_USER_CREATION_LABEL: 'Vuoi creare un nuovo account Master o Base?',
  MASTER_USER_CREATION_LABEL: 'Vuoi creare un nuovo account Direttore?',
  DIRECTOR_USER_CREATION_LABEL: 'Vuoi creare un nuovo account Buyer?',
  BUYER_USER_CREATION_LABEL: 'Vuoi creare un nuovo account Base?',
  REDIRECT_LOGIN: 'Vai al LOGIN',
  REQUEST_TOCONFIRM: 'Richieste in sospeso',
  ACCOUNTS_TITLE: 'Account clienti',
  ACCOUNTS_TITLE2: 'Account non clienti',
  ACCOUNTS_TITLE3: 'Account Redattore',
  ACCOUNTS_TOCONFIRM: 'Account da confermare',
  ACCOUNTS_ASK_CONFIRM: 'Sei sicuro di voler approvare il seguente account?',
  ACCOUNTS_ASK_REFUSE: 'Sei sicuro di voler rifiutare il seguente account?',
  ACCOUNTS_ASK_REMOVE: 'Sei sicuro di voler eliminare il seguente account?',
  DOCUMENT_COMPLETED: 'completetato',
  DOCUMENT_REVIEW: 'review',
  DOCUMENT_INCOMPLETE: 'da completare',
  DOCUMENTS_REQUESTED: 'documenti richiesti',
  DOCUMENTS_ADD: 'Aggiungi dati tecnici',
  DOCUMENTS_SOURCE_NETTUNO: 'Nettuno',
  DOCUMENTS_SOURCE_CUSTOM: 'Manuale',
  DOCUMENTS_EMPTY: 'Nessun documento disponibile',
  BUSINESS_BUYERNAME: 'nome buyer',
  BUSINESS_BUYERNAME_SEARCH: 'nome buyer',
  BUSINESS_REQUESTINGCOMPANY: 'Azienda richiedente',
  BUSINESS_STATUS: 'Stato BI',
  BUSINESS_GENERIC_DATA: 'Dati Generali',
  REPORT_TITLE: 'Report',
  QUICK_REPORT_TITLE: 'Quick Report',
  BUSINESS_INFORMATION_TITLE: 'Business Information',
  BUSINESS_INFORMATION_REQUESTEDBY: 'Richiedente',
  BUSINESS_INFORMATION_BUYORDER: 'Data di aggiornamento',
  BUSINESS_INFORMATION_EDITOR: 'redattore',
  BUSINESS_INFORMATION_NOTES: 'Aspetti più interessanti dell\'indagine per il cliente',
  BUSINESS_INFORMATION_LANGUAGE: 'Lingua',
  BUSINESS_INFORMATION_ADDRESS: 'Indirizzo sede principale',
  BUSINESS_INFORMATION_NUMEMPLOYEES: 'Numero dipendenti',
  BUSINESS_INFORMATION_FOUNDEDIN: 'Data di costruzione',
  BUSINESS_INFORMATION_COREBUSINESS: 'Attività principale',
  BUSINESS_INFORMATION_ESTATE: 'Presenza immobili società',
  BUSINESS_INFORMATION_WAITING_TI: 'Siamo in attesa dei dati tecnici...',
  BUSINESS_INFORMATION_TECHDOC_LINK: 'link al dato tecnico',
  BUSINESS_CLOSING_COMMENT: 'Chiusura report',
  BUSINESS_INFORMATION_SAVETEXT: 'Vuoi confermare come completato?',
  TECHDOC_SAVEQUESTION: 'Vuoi salvare definitivamente i dati ufficiali?',
  ORDERS_WIZARD_TITLE: 'Ricerca Aziende',
  ORDERS_WIZARD_SEARCH_LABEL: 'Cerca per:',
  ORDERS_WIZARD_RADIO_NAME: 'Denominazione',
  ORDERS_WIZARD_PLACEHOLDER_PROVINCE: 'Provincia',
  ORDERS_WIZARD_INVESTIGATION_CODE: 'Codice Azienda',
  ORDERS_WIZARD_INVESTIGATION_CODE_PLACEHOLDER: 'e.g. ADFD12',
  ORDERS_WIZARD_INVESTIGATION_SUBCODE: 'Sottocodice Azienda',
  ORDERS_WIZARD_INVESTIGATION_SUBCODE_PLACEHOLDER: 'e.g. ADFD12',
  ORDERS_WIZARD_FIRST_NAME_LABEL: 'Inserisci il nome del referente dell’azienda:',
  ORDERS_WIZARD_REPRESENTATIVE_FIRST_NAME_PLACEHOLDER: 'e.g. John',
  ORDERS_WIZARD_LAST_NAME_LABEL: 'Inserisci il cognome del referente dell’azienda:',
  ORDERS_WIZARD_REPRESENTATIVE_LAST_NAME_PLACEHOLDER: 'e.g. Appleseed',
  ORDERS_WIZARD_EMAIL_LABEL: 'Inserisci la mail del referente dell’azienda:',
  ORDERS_WIZARD_REPRESENTATIVE_EMAIL_PLACEHOLDER: 'e.g. john.appleseed@email.com',
  ORDERS_WIZARD_PHONE_LABEL: 'Inserisci il numero di telefono del referente dell’azienda:',
  ORDERS_WIZARD_REPRESENTATIVE_PHONE_PLACEHOLDER: 'e.g. +39 345 1234567',
  ORDERS_WIZARD_REASON_LABEL: 'Note',
  ORDERS_WIZARD_REASON_PLACEHOLDER: 'Inserisci le note e i punti di interesse per l\'indagine...',
  ORDERS_WIZARD_BUSINESS_NAME_PLACEHOLDER: 'e.g. Appleseed Corporation',
  ORDERS_WIZARD_FISCAL_CODE_PLACEHOLDER: 'e.g. 0000000000',
  ORDERS_WIZARD_REA_NUMBER_PLACEHOLDER: 'e.g. 0000000000',
  ORDERS_WIZARD_VAT_NUMBER_PLACEHOLDER: 'e.g. 0000000000',
  ORDERS_WIZARD_ADDRESS_LABEL: 'Indirizzo dello stabilimento da investigare',
  ORDERS_WIZARD_ADDRESS_PLACEHOLDER: 'Indirizzo dello stabilimento',
  ORDERS_WIZARD_FOREIGN_CITY_PLACEHOLDER: 'e.g. Londra',
  SEARCH_RESULTS: 'Risultati della ricerca',
  SEARCH_RESULTS_LEGAL_HEAD_OFFICE: 'Sede legale',
  SEARCH_RESULTS_LOCATION: 'Provincia',
  SEARCH_RESULTS_LEGAL_STATUS: 'Forma giuridica',
  SEARCH_RESULTS_COREBUSINESS: 'Attività',
  SEARCH_RESULTS_ADDRESS: 'Indirizzo sede',
  SEARCH_RESULTS_REGISTRATION_NUMBER: 'Numero di Registrazione',
  SEARCH_RESULTS_DUNS: 'Numero Duns',
  SEARCH_RESULTS_PROVINCE_REA: 'Prov./ N. Rea',
  SEARCH_RESULTS_STATUS: 'Stato impresa',
  SEARCH_RESULTS_LOADING: 'Stiamo caricando i risultati della ricerca...',
  SEARCH_COMPANY: 'Cerca azienda',
  LOGIN_TITLE: 'Accedi a Nando.',
  LOGIN_SUBTITLE: 'Digita le tue credenziali qui sotto.',
  LOGIN_USERNAME_LABEL: 'Indirizzo email',
  LOGIN_PASSWORD_LABEL: 'Password',
  LOGIN_PASSWORD_PLACEHOLDER: 'Digita la tua password',
  LOGIN_SUBMIT: 'Accedi',
  LOGIN_FORGOT_PASSWORD_CTA: 'Password dimenticata?',
  TABLE_GENERIC_EMPTY_LIST: 'Non è presente alcun elemento',
  TABLE_BI_EMPTY_LIST: 'Non è presente alcuna Business Information per questa compagnia',
  RESET_PASSWORD_TITLE: 'Reset password',
  RESET_PASSWORD_SUBTITLE: 'Digita la tua nuova password.',
  RESET_PASSWORD_CTA: 'Imposta nuova password',
  RESET_PASSWORD_SUCCESS_TITLE: 'Finito!',
  RESET_PASSWORD_SUCCESS_INSTRUCTIONS: 'Ora puoi autenticarti con la nuova password che hai scelto.',
  RESET_PASSWORD_REQUEST_TITLE: 'Hai dimenticato la tua password?',
  RESET_PASSWORD_REQUEST_SUBTITLE: 'Digita il tuo indirizzo email e ti aiuteremo a recuperarla.',
  RESET_PASSWORD_REQUEST_CTA: 'Richiedi link di reset',
  RESET_PASSWORD_REQUEST_SUCCESS_TITLE: 'Abbiamo quasi finito...',
  RESET_PASSWORD_REQUEST_SUCCESS_INSTRUCTIONS: 'Ti abbiamo inviato una mail all\'indirizzo che ci hai fornito con le istruzioni per impostare la nuova password del tuo account.',
  RESET_PASSWORD_BACK_TO_LOGIN_CTA: 'Torna al login',
  RESET_PASSWORD_VALIDATION_FAILED_TITLE: 'Qualcosa non va...',
  CHANGE_PASSWORD_TITLE: 'Cambia password',
  CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD: 'Password attuale',
  CHANGE_PASSWORD_LABEL_NEW_PASSWORD: 'Nuova password',
  CHANGE_PASSWORD_LABEL_PASSWORD_CONFIRMATION: 'Conferma nuova password',
  CHANGE_PASSOWRD_CTA: 'Salva password',
  CHANGE_PASSWORD_SECONDARY_CTA: 'Annulla',
  CHANGE_PASSWORD_SUCCESS: 'Password aggiornata con successo.',
  ORDERS_TITLE: 'Ordini',
  ORDERS_TITLE_PENDING: 'Ordini in sospeso',
  ORDERS_TITLE_ARCHIVED: 'Ordini Archiviati',
  ORDERS_TITLE_EDITED: 'Ordini Riaperti',
  ORDERS_QUESTIONNAIRES: 'Questionari',
  ORDERS_EMPTY_LIST_MESSAGE: 'Nessun ordine disponibile',
  ORDER_MAKE: 'Crea ordine',
  QUESTIONNAIRE_CHECK_TITLE: 'check form',
  QUESTIONNAIRE_ASSESSMENT_TITLE: 'self assessment',
  STATUS_APPROVED: 'Approvato',
  STATUS_REJECTED: 'Respinto',
  STATUS_REVIEWING: 'In revisione',
  ACCOUNT_TYPE_EDITOR: 'Redattore',
  ACCOUNT_TYPE_MASTER: 'Master',
  ACCOUNT_TYPE_DIRECTOR: 'Direttore',
  ACCOUNT_TYPE_BUYER: 'Buyer',
  ACCOUNT_TYPE_BASE: 'Base',
  TABLE_HEADER_NAME: 'Nome',
  TABLE_HEADER_COMPANY: 'Azienda',
  TABLE_HEADER_STATUS: 'Stato',
  TABLE_HEADER_ACCOUNT_TYPE: 'Tipo account',
  TABLE_HEADER_INSERTED_BY: 'Aggiunto da',
  TABLE_HEADER_ACTIVE: 'Attivo',
  TABLE_HEADER_TYPE: 'Tipo',
  TABLE_HEADER_ACCOUNTS_COUNT: '# Account',
  TABLE_HEADER_ORDERS_COUNT: '# Ordini',
  TABLE_HEADER_PENDING_ORDERS_COUNT: '# Ordini Pending',
  TABLE_HEADER_COUNTRY: 'Paese',
  MODAL_TITLE_CREATE_ACCOUNT: 'Crea nuovo account {{userType}}',
  MODAL_TITLE_APPROVE_ACCOUNT: 'Approva account',
  MODAL_TITLE_REJECT_ACCOUNT: 'Respingi account',
  CREATE_ACCOUNT_COMPANY_LABEL: 'Azienda',
  CREATE_ACCOUNT_COMPANY_PLACEHOLDER: 'Seleziona un\'azienda...',
  CREATE_ACCOUNT_FIRST_NAME_LABEL: 'Nome',
  CREATE_ACCOUNT_FIRST_NAME_PLACEHOLDER: 'John',
  CREATE_ACCOUNT_LAST_NAME_LABEL: 'Cognome',
  CREATE_ACCOUNT_LAST_NAME_PLACEHOLDER: 'Appleseed',
  CREATE_ACCOUNT_EMAIL_LABEL: 'Email',
  CREATE_ACCOUNT_EMAIL_PLACEHOLDER: 'john.appleseed@email.com',
  CREATE_ACCOUNT_CTA_CREATE: 'Crea',
  CREATE_ACCOUNT_CTA_CANCEL: 'Annulla',
  APPROVE_ACCOUNT_CTA: 'Approva',
  REJECT_ACCOUNT_CTA: 'Respingi',
  APPROVE_REJECT_ACCOUNT_CTA_CANCEL: 'Annulla',
  REJECT_ACCOUNT_REASON_LABEL: 'Motivazione',
  REJECT_ACCOUNT_REASON_PLACEHOLDER: '(Opzionale) Scrivi la motivazione del respingimento...',
  ORDERS_PLACE_DESCRIPTION: 'Vuoi saperne di più su un\'azienda?',
  ORDERS_PLACE_CTA: 'Nuovo ordine',
  ORDERS_REQUEST_CTA: 'Richiedi',
  QUESTIONNAIRE_EXPORT_FACSIMILE: 'Esporta fac-simile',
  QUESTIONNAIRE_SA_SEND_QUESTION: 'Vuoi inviare definitivamente una nuova versione del Self Assessment?',
  QUESTIONNAIRE_CF_SEND_QUESTION: 'Vuoi inviare definitivamente una nuova versione del Check Form?',
  QUESTIONNAIRE_ITEM_INPUT_PLACEHOLDER: 'Inserisci {{fieldName}}',
  QUESTIONNAIRE_ITEM_TEXTAREA_PLACEHOLDER: 'Inserisci il testo',
  QUESTIONNAIRE_ITEM_INPUT_GENERIC_PLACEHOLDER: 'Inserisci valore',
  TABLE_CONTRACT_EMPTY_LIST: 'Non è presente alcun contratto per questa compagnia',
  TABLE_CONTRACT_VALID_FROM: 'Valido da',
  TABLE_CONTRACT_VALID_UNTIL: 'Valido fino a',
  TABLE_CONTRACT_NUMBER: 'Numero',
  TABLE_CONTRACT_DOCUMENT: 'Documento',
  TABLE_CONTRACT_CREDITS: 'Crediti',
  CONTRACT_EDIT: 'Modifica contratto',
  CONTRACT_CREATE: 'Crea contratto',
  CONTRACT_NUMBER: 'Numero del contratto',
  CONTRACT_VALID_FROM: 'Contratto valido da',
  CONTRACT_VALID_UNTIL: 'Contratto valido fino a',
  CONTRACT_DOCUMENT: 'Allega nuovo documento',
  CONTRACT_EDIT_CANCEL: 'Annulla',
  CONTRACT_CREATION_LABEL: 'Vuoi inserire un nuovo contratto?',
  CONTRACT_CREATION_BUTTON: 'crea contratto',
  PRICE_LIST: 'Prezzario',
  USE_DEFAULT_PRICE_LIST: 'Usa prezzario di default',
  QUESTIONNAIRE_SEND_QUESTION: 'Vuoi inviare definitivamente questa versione del {{title}}?',
  TABLE_EMPTY_REVIEWING_ACCOUNTS: 'Non ci sono account da approvare al momento.',
  GO_TO_NANDO_CTA: 'Vai a Nando',
  GO_TO_FORM_CTA: 'Scopri di più',
  CONFIRM_DELETE_DOCUMENT_MESSAGE: 'Confermi di voler eliminare il documento?',
  QUESTIONNAIRE_DOCUMENTS_NOT_UPLOADED: 'Nessun documento caricato',
  ORDER_CONTACT_PERSON_TITLE: 'Referente dell\'azienda',
  ORDER_CONTACT_PERSON_NAME: 'Nominativo',
  ORDER_CONTACT_PERSON_EMAIL: 'Indirizzo email',
  ORDER_CONTACT_PERSON_PHONE: 'Telefono',
  ORDER_INVESTIGATION_TITLE: 'Codici investigazione',
  ORDER_INVESTIGATION_UPDATE: 'Aggiorna codici',
  ORDER_REASON_TITLE: 'Note',
  QUESTIONNAIRE_REJECT: 'Respingi Questionario',
  QUESTIONNAIRE_APPROVE: 'Approva Questionario',
  QUESTIONNAIRES_TOCONFIRM: 'Questionari da confermare',
  HOME_SHOW_PREV: 'Mostra pagina precedente',
  HOME_SHOW_NEXT: 'Mostra pagina successiva',
  COMPLIANCE_TOOLTIP: 'I risultati positivi sotto indicati potrebbero essere attribuiti ad omonimi. Richiedi un approfondimento via email',
  COMPANY_BUDGETS_CONTRACT: 'Tutti i budget assegnati agli account fanno riferimento al seguente contratto attivo:',
  COMPANY_BUDGETS_CONTRACT_NUMBER: 'Numero',
  COMPANY_BUDGETS_CONTRACT_CREDITS: 'Crediti',
  COMPANY_BUDGETS_CONTRACT_VALID_FROM: 'Valido da',
  COMPANY_BUDGETS_CONTRACT_VALID_UNTIL: 'Valido fino a',
  COMPANY_BUDGETS_CONTRACT_EDIT_CTA: 'Se vuoi modificarlo, vai nella sezione CONTRATTI della compagnia.',
  COMPANY_STRUCTURE_DIRECTOR_EMPTY: 'Nessun account DIRETTORE disponibile.',
  COMPANY_STRUCTURE_BASE_EMPTY: 'Nessun account BASE disponibile.',
  USERS_BASE_LIST: 'Base',
  COMPLETE_ORDER_MODAL_TITLE: 'Completa ordine',
  COMPLETE_ORDER_MODAL_DESCRIPTION_GENERAL: 'Stai per completare l\'ordine fatto da {{buyerName}} per l\'azienda {{companyName}}.',
  COMPLETE_ORDER_MODAL_DESCRIPTION_ATTACH_MESSAGE: '{{buyerName}} riceverà una notifica tramite mail. Allega un commento conclusivo che verrà allegato al report finale dell\'ordine.',
  COMPLETE_ORDER_MODAL_MESSAGE_LABEL: 'Conclusioni',
  COMPLETE_ORDER_MODAL_MESSAGE_PLACEHOLDER: 'Digita il commento da allegare al report',
  COMPLETE_ORDER_MODAL_CONFIRM_CTA: 'Conferma',
  COMPLETE_ORDER_MODAL_CANCEL_CTA: 'Annulla',
  ORDER_COMPLETE_CTA: 'Completa ordine',
  REOPEN_ORDER_MODAL_DESCRIPTION_ATTACH_MESSAGE: '{{buyerName}} riceverà una notifica tramite mail. Se ritieni opportuno, puoi allegare un messaggio che verrà recapitato insieme alla notifica.',
  REOPEN_ORDER: 'Riapri ordine',
  REOPEN_ORDER_MODAL_MESSAGE_LABEL: 'Messaggio',
  REOPEN_ORDER_MODAL_DESCRIPTION_GENERAL: 'Stai per riaprire l\'ordine fatto da {{buyerName}} per l\'azienda {{companyName}}.',
  NO_USERS_TO_CONFIRM: 'Non sono presenti account da confermare',
  NO_QUESTIONNAIRES_TO_CONFIRM: 'Non sono presenti questionari da confermare',
  BUSINESS_INFORMATION_EMPTY_LIST: 'Nessun elemento da visualizzare.',
  SCORE_DESCRIPTION: 'Descrizione score',
  ORDER_RECAP: 'Riepilogo ordine',
  TABLE_HEADER_QUICK_SCORE: 'Quick Report',
  TABLE_HEADER_NANDO_SCORE: 'Nando Rating',
  TABLE_HEADER_NANDO_PLUS_SCORE: 'Nando Rating+',
  REPUTATION: 'Reputazione e credibilità',
  PRODUCT_DESCRIPTION_QUICK_REPORT: 'Quick Report',
  PRODUCT_DESCRIPTION_BASE: 'Business Information',
  PRODUCT_DESCRIPTION_TOP: 'Nando Rating',
  PRODUCT_DESCRIPTION_PREMIUM: 'Nando Rating+',
  PRODUCT_DESCRIPTION_QUALITY_SCORE: 'Quality Score',
  PRODUCT_DESCRIPTION_MATCH_SCORE: 'Match Score',
  PRODUCT_DESCRIPTION_ALERTS_CHECK: 'Alerts Check',
  PRODUCT_DESCRIPTION_COMPLIANCE: 'Compliance',
  PRODUCT_DESCRIPTION_PEP: 'Persone politicamente esposte',
  PRODUCT_DESCRIPTION_LEGAL_EVENTS: 'Eventi Legali',
  ORDERS_LIST_PRODUCT_DESCRIPTION_QUICK_REPORT: 'QUICK REPORT',
  ORDERS_LIST_PRODUCT_DESCRIPTION_BASE: 'BUSINESS INFORMATION',
  ORDERS_LIST_PRODUCT_DESCRIPTION_TOP: 'NANDO RATING',
  ORDERS_LIST_PRODUCT_DESCRIPTION_PREMIUM: 'NANDO RATING+',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_QUICK_REPORT: 'Report su aziende in tempo reale con Rating, Fido, controlli Compliance, verifica negatività e controllo titolare effettivo. Il Rating ed il Fido vengono calcolati tramite algoritmo automatico.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_BASE: 'Analisi su azienda con evasione posticipata e con una valutazione puntuale effettuata da un analista partendo dalle informazioni presenti nel QUICK REPORT. Il Rating ed il Fido vengono validati dall\'analista.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_TOP: 'Integrazione nella BUSINESS INFORMATION delle informazioni emerse nel questionario CHECK FORM, che è compilato dall\'azienda analizzata su tuo invito, e che permette di ottenere ulteriori elementi aggiornati quali Certificazioni, Regolarità nel pagamento delle tasse, eventuali impatti Covid-19 ecc. Questa analisi assegna uno specifico Rating.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_PREMIUM: 'Integrazione del NANDORATING con il questionario SELF ASSESSMENT compilato per valutare uno o più stabilimenti e sedi di un\'azienda. L\'analisi dei dati risultanti da tale integrazione attribuisce uno specifico Rating.',
  BI_SAVE_AND_CONFIRM_CTA: 'Salva e conferma',
  COMPANY_EDIT: 'Modifica compagnia',
  TABLE_HEADER_LAST_UPDATED_AT: 'Ultimo aggiornamento',
  BUSINESS_INFORMATION_TRUST_STATEMENT_LABEL: 'Fido',
  SCORE_LEGEND_TITLE: 'Legenda',
  SCORE_LEGEND_DESCRIPTION_CRITICAL: 'Critico',
  SCORE_LEGEND_DESCRIPTION_WEAK: 'Debole',
  SCORE_LEGEND_DESCRIPTION_FAIR: 'Discreto',
  SCORE_LEGEND_DESCRIPTION_GOOD: 'Buono',
  SCORE_LEGEND_DESCRIPTION_EXCELLENT: 'Ottimo',
  SCORE_LEGEND_BASE_DESCRIPTION_CRITICAL: 'Azienda estremamente vulnerabile, in ritardo nei pagamenti con indebitamento molto elevato e difficoltà organizzative. Presenza di negatività ufficiali e/o Azienda neo costituita ed in fase di avviamento.',
  SCORE_LEGEND_BASE_DESCRIPTION_WEAK: 'Azienda attualmente vulnerabile. La solvibilità dei debiti assunti dipende prevalentemente da condizioni economiche e finanziarie favorevoli. Dati di bilancio con trend negativo. Emerge un indebitamento elevato ma ancora sostenibile e/o Azienda che è operativa da poco tempo e che necessita di consolidamento. Azienda poco conosciuta sul mercato.',
  SCORE_LEGEND_BASE_DESCRIPTION_FAIR: 'Azienda con adeguate capacità di rispettare gli obblighi assunti. Tuttavia, condizioni economiche avverse possono generare una minore capacità di adempiere agli obblighi assunti. Azienda di modeste dimensioni e con risultati economici/patrimoniali nel complesso discreti. Azienda sufficientemente ben introdotta nel settore di appartenenza.',
  SCORE_LEGEND_BASE_DESCRIPTION_GOOD: 'Azienda con buone capacità di rispettare gli obblighi assunti. Dimostra un buon equilibrio economico finanziario ed una buona struttura. I dati di bilancio sono soddisfacenti e con andamenti positivi.',
  SCORE_LEGEND_BASE_DESCRIPTION_EXCELLENT: 'Azienda con eccellenti capacità di onorare le obbligazioni assunte e con una costante crescita negli ultimi anni. Struttura consolidata. Azienda solida e con risultati economici/patrimoniali ottimali.',
  SCORE_LEGEND_TOP_DESCRIPTION_CRITICAL: 'Azienda che opera in aree ove vi è un Rischio Paese molto elevato. Presenta un numero di siti produttivi non controllati o in aree con Rischio Paese molto elevato. Certificazioni di processo assenti o inadeguate. Tax compliance assente o non conforme. Poca collaborazione nella profilazione aziendale.',
  SCORE_LEGEND_TOP_DESCRIPTION_WEAK: 'Azienda che opera in aree ove vi è un Rischio Paese elevato. Presenta un numero di siti produttivi non controllati o in aree con Rischio Paese elevato. Certificazioni di processo scadute e non rinnovate. Tax compliance assente o non conforme. Poca collaborazione nella profilazione aziendale.',
  SCORE_LEGEND_TOP_DESCRIPTION_FAIR: 'Azienda che opera in aree ove vi è un Rischio Paese medio. Presenta un numero di siti produttivi controllati e in aree con Rischio Paese medio. Certificazioni di processo in fase di scadenza o in fase di rinnovo. Tax compliance in scadenza. Discreta collaborazione nella profilazione aziendale.',
  SCORE_LEGEND_TOP_DESCRIPTION_GOOD: 'Azienda che opera in aree ove vi è un Rischio Paese basso. Presenta un numero di siti produttivi controllati e in aree con Rischio Paese basso. Poche certificazioni di processo attive. Tax compliance aggiornata. Buona collaborazione nella profilazione aziendale.',
  SCORE_LEGEND_TOP_DESCRIPTION_EXCELLENT: 'Azienda che opera in aree ove vi è un Rischio Paese minimo. Presenta un numero di siti produttivi controllati e in aree con Rischio Paese minimo. Certificazioni di processo complete. Tax compliance aggiornata. Ottima collaborazione nella profilazione aziendale.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_CRITICAL: 'Stabilimento mal strutturato e disorganizzato. Ubicato in nazione con un Rischio Paese molto elevato. Misure di sicurezza assenti o totalmente inadeguate. Sistemi di safety assenti o totalmente inadeguati. Mancanza di sistemi di continuità energetica ed infrastrutture tecnologiche assenti o totalmente inadeguate.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_WEAK: 'Stabilimento mediocre e poco organizzato. Ubicato in nazione con un Rischio Paese elevato. Misure di sicurezza scarse. Sistemi di safety scarsi. Mancanza di sistemi di continuità energetica ed infrastrutture tecnologiche inadeguate.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR: 'Stabilimento discretamente organizzato. Ubicato in nazione con un Rischio Paese medio. Misure di sicurezza discrete. Sistemi di safety discreti. Presenza di sistemi di continuità energetica ed infrastrutture tecnologiche discrete.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_GOOD: 'Stabilimento ben organizzato. Ubicato in nazione con un Rischio Paese basso. Misure di sicurezza buone. Sistemi di safety buoni. Presenza di sistemi di continuità energetica ed infrastrutture tecnologiche buone.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_EXCELLENT: 'Stabilimento in perfette condizioni e ben organizzato. Ubicato in nazione con un Rischio Paese minima. Misure di sicurezza ottime. Sistemi di safety ottimi. Presenza di sistemi di continuità energetica ed infrastrutture tecnologiche all\'avanguardia.',
  QUESTIONNAIRE_PREVIEW_SCORE_LABEL: 'Punteggio parziale derivante dalle risposte date al questionario',
  QUESTIONNAIRE_FINAL_SCORE_LABEL: 'Punteggio finale',
  GENERIC_REQUIRED_FIELDS: 'Campi obbligatori',
  GENERIC_OPTIONAL_FIELDS: 'Campi facoltativi',
  PLACING_ORDER_LOADING: 'Stiamo processando il tuo ordine. Ci vorranno soltanto alcuni secondi...',
  QUESTIONNAIRE_MAX_SIZE_UPLOAD: 'Massimo 50 MB',
  PRIVACY_POLICY_ACCEPTED: 'Ho letto e accetto le',
  UPDATED: 'Aggiornato il',
  COMING_SOON: 'Presto disponibile',
  NO_MATCHES_FOUND: 'Nessun problema',
  MATCHES_FOUND: 'Problemi trovati',
  VALUES_YES: 'Si',
  VALUES_NO: 'No',
  NO_ELEMENTS_TO_VIEW: 'Non ci sono elementi da visualizzare',
  SET_QUESTIONNAIRE_TO_DRAFT: 'Riporta il Questionario in bozze',
  SET_QESTIONNAIRE_TO_DRAFT_MESSAGE: 'Indicare di seguito le modifiche da apportare al questionario (obbligatorio).',
  SET_BUSINESSINFO_TO_DRAFT: 'Riporta la Business Information in bozze',
  SET_BUSINESSINFO_TO_DRAFT_MESSAGE: 'Indicare di seguito le modifiche da apportare alla Business Info (obbligatorio).',
  SET_TECH_DOC_TO_DRAFT: 'Riporta il dato tecnico in bozze',
  GENERIC_CONTACT: 'Contatti',
  GENERIC_WEBSITE: 'Sito web',
  GENERIC_ELECTRONIC_INVOICE: 'SDI Fattura elettronica',
  GENERIC_VARIOUS: 'Varie',
  ORDERS_SUMMARY: 'Riepilogo ordini',
  GENERIC_TECH_DOC: 'Documento tecnico',
  DUPLICATE_FIELDS: 'Duplica campi',
  GENERIC_REMOVE: 'Elimina',
  USER_EDIT: 'Modifica utente',
  USER_REMOVE: 'Elimina utente',
};

export default translations;
